import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAuth } from '../../hooks/useAuth';
import { useUIStore } from '../../store/uiStore';

export function MainLayout() {
  const { user, loading } = useAuth();
  const { sidebarPinned } = useUIStore();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: 'var(--surface-base)' }}
      >
        <div
          className="w-8 h-8 rounded-full border-2 border-t-transparent animate-spin"
          style={{ borderColor: 'var(--accent-primary)', borderTopColor: 'transparent' }}
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const sidebarWidth = sidebarPinned ? 'var(--sidebar-expanded)' : 'var(--sidebar-collapsed)';

  return (
    <div className="min-h-screen" style={{ background: 'var(--surface-base)' }}>
      <Sidebar />
      <TopBar />
      <main
        className="transition-all duration-200"
        style={{
          marginLeft: sidebarWidth,
          paddingTop: 'var(--topbar-height)',
          minHeight: '100vh',
        }}
      >
        <div className="p-5">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
